import { connect } from "react-redux";
import { quiz3MetaWatch } from "../../actions/quiz3Actions";
import WatchMeta from "../quiz/WatchMeta";

const mapStateToProps = state => ({
  quizN: state.quiz3
});

export default connect(
  mapStateToProps,
  { quizNMetaWatch: quiz3MetaWatch }
)(WatchMeta);
